<template>
    <page>
        <module title="砍价活动详情">
            <div v-if="activityInfo">
                <c-detail title="基础信息">
                    <c-detail-item label="活动名称">{{activityInfo.activity_name}}</c-detail-item>

                    <c-detail-item label="活动时间">{{activityInfo.begin_date}} - {{activityInfo.end_date}}</c-detail-item>

<!--                    <c-detail-item label="分享标题">{{activityInfo.share_title}}</c-detail-item>-->

<!--                    <c-detail-item label="分享助力语">{{activityInfo.share_describe}}</c-detail-item>-->

                    <c-detail-item label="发起人数">{{activityInfo.launch_count}}</c-detail-item>

                    <c-detail-item label="帮砍人次">{{activityInfo.bargain_count}}</c-detail-item>

                    <c-detail-item label="订单数">{{activityInfo.order_count}}</c-detail-item>

                    <c-detail-item label="砍至底价人数">{{activityInfo.bargain_success_count}}</c-detail-item>

                    <c-detail-item label="底价成交订单">{{activityInfo.min_price_order_count}}</c-detail-item>

                    <c-detail-item label="活动商品" full>
                        <c-table v-model="productList" height="auto" border>

                            <c-table-column
                                    label="商品信息"
                                    name="product_name"
                                    width="250"
                            >
                                <template v-slot="{data}">
                                    <product-info :image="data.product_img_url" :name="(data.product_itemnumber||'') + ' ' + data.product_name"></product-info>
                                </template>
                            </c-table-column>

                            <c-table-column
                                label="商品货号"
                                name="product_itemnumber"
                                width="100"
                            ></c-table-column>

                            <c-table-column
                                label="商品状态"
                                name="state"
                                width="80"
                            >
                              <template v-slot="{data}">
                                <span v-if="data.activity_product_id==null" style="color:gray">待保存</span>
                                <span v-if="data.activity_product_id && data.state == 0" style="color:red">已结束</span>
                                <span v-if="data.activity_product_id && data.state == 1" style="color:green">正常</span>
                              </template>
                            </c-table-column>
                            <c-table-column
                                    label="价格"
                                    name="product_price"
                                    width="130"
                            >
                                <template v-slot="{data}">￥{{data.product_price}}</template>
                            </c-table-column>

                            <c-table-column
                                    label="库存"
                                    name="stock_count"
                                    width="70"
                            ></c-table-column>

                            <c-table-column
                                    label="帮砍人数"
                                    name="bargain_user_limit"
                                    width="70"
                            ></c-table-column>

                            <c-table-column
                                    label="是否底价下单"
                                    name="min_price_order"
                                    width="110"
                            >
                                <template v-slot="{data}">{{data.min_price_order == 1 ? "必须底价下单" : "允许中途下单"}}</template>
                            </c-table-column>

                            <c-table-column
                                    label="帮砍底价"
                                    width="80"
                            >
                                <template v-slot="{data}">
                                    ￥{{data.min_sale_price}}
                                </template>
                            </c-table-column>

                        </c-table>
                    </c-detail-item>
                </c-detail>
            </div>
        </module>
    </page>
</template>

<script>
    import productInfo from '@/components/public/product_info.vue'
    import {mapState} from 'vuex'

    export default {
        name: 'activity_bargain_detail',

        props: {
            id: String
        },

        components: {
            productInfo
        },

        data() {
            return {
                activityInfo: '',
                userLevelStr: '',
                userLevelArr: [],
                productList: []
            }
        },

        computed: {
            ...mapState(['dict'])
        },

        watch: {
            id() {
                this.getActivityDetail();
            }
        },

        mounted() {
            this.getActivityDetail();
        },

        methods: {
            getActivityDetail() {
                this.request({
                    url: '/activityBargain/detail',
                    data: {
                        id: this.id
                    },
                    loading: true,
                    success: data => {
                        this.activityInfo = data;
                        this.productList = data.product_list;
                    }
                });
          }
        }
    }
</script>